"use strict";
export const loopProductGallery = (productID) => ({
    productID,
    images: window.images[productID] || [],
    visible: 0,
    changing: false,
    animationDuration: 0,
    prev() {
        this.changing = this.animationDuration > 0;
        setTimeout(() => {
            this.visible--;
            if (this.visible < 0) this.visible = this.images.length - 1;
            if (this.changing) {
                this.changing = false;
            }
        }, this.animationDuration)
    },
    next() {
        this.changing = this.animationDuration > 0;
        setTimeout(() => {
            this.visible++;
            if (this.visible >= this.images.length) this.visible = 0;
            if (this.changing) {
                this.changing = false;
            }
        }, this.animationDuration)
    },
})